var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgGame = function SvgGame(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M10.458 2.3a.498.498 0 0 0-.913-.007l-2.39 5.258-5.737.956a.5.5 0 0 0-.195.91l4.226 2.817-.94 5.177a.5.5 0 0 0 .715.536L10 15.56l4.776 2.388a.5.5 0 0 0 .716-.536l-.941-5.177 4.226-2.818a.5.5 0 0 0-.195-.909l-5.737-.956zM10 3.707l-2.045 4.5a.5.5 0 0 1-.373.285l-4.753.793 3.448 2.298a.5.5 0 0 1 .215.506l-.821 4.516 4.1-2.05A.5.5 0 0 1 10 14.5a.5.5 0 0 1 .229.055l4.1 2.05-.82-4.515a.5.5 0 0 1 .214-.506l3.448-2.298-4.753-.793a.5.5 0 0 1-.373-.286z",
    clipRule: "evenodd"
  })));
};
export default SvgGame;